import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";

import { Gap, MyButton } from "../../atoms";
import AlamatKantor from "./AlamatKantor";
import BankKantor from "./BankKantor";
import DokumenKepengurusan from "./DokumenKepengurusan";
import Paper from "@mui/material/Paper";
import DokumenKantor from "./DokumenKantor";
import DokumenBank from "./DokumenBank";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getExcoDocument } from "../../../config/Redux/Global/actions";
import { getDetailExcoPusat } from "../../../config/Redux/ExcoPusat/actions";
import { postLockUnlock } from "../../../config/Redux/ExcoDetailPusat/actions";
import { useDispatch, useSelector } from "react-redux";
import Table from "./Table";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Tooltip from "@mui/material/Tooltip";
// Import SharedTabPanel
import SharedTabPanel from "../../molecules/SharedTabPanel";
import ExcoRTRW from "./ExcoRTRW";

const DetailExcoPusat = () => {
  const dispatch = useDispatch();
  let params = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  let nameExco = state.nameExco;

  // Local state to track loading status of lock action
  const [isLockActionLoading, setIsLockActionLoading] = React.useState(false);
  const [activeTopTab, setActiveTopTab] = React.useState(0);

  // Use real Redux state for all exco types
  const dataDoc = useSelector((state) => state.global.dataExcoDocument);
  const dataDetailExcoPusat = useSelector(
    (state) => state.excopusat.dataDetailExcoPusat,
  );

  const breadcrumbs = [
    <div
      onClick={() => navigate(-1)}
      style={{
        textDecoration: "none",
        fontWeight: "bold",
        color: "black",
        fontSize: "14px",
        cursor: "pointer",
      }}
      key="1"
    >
      {nameExco === "EXCO KabKot" ? "EXCO Kab/Kot" : nameExco}
    </div>,
    <Typography
      key="2"
      color="text.primary"
      style={{ color: "#BDBDBD", fontSize: "14px", marginTop: "2px" }}
    >
      Dokumen SIPOL
    </Typography>,
  ];

  let dataDocMap = dataDoc?.data;

  // doc pengurusan
  let docPengurusan = dataDocMap?.filter(
    (item) =>
      item.kategori_dokumen.id === 1 ||
      item.kategori_dokumen.id === 2 ||
      item.kategori_dokumen.id === 9 ||
      item.kategori_dokumen.id === 7 ||
      item.kategori_dokumen.id === 8 ||
      item.kategori_dokumen.id === 10 ||
      item.kategori_dokumen.id === 11 ||
      item.kategori_dokumen.id === 12 ||
      item.kategori_dokumen.id === 13 ||
      item.kategori_dokumen.id === 14 ||
      (item.kategori_dokumen.id === 16 &&
        (nameExco === "EXCO Pusat" ||
          nameExco === "EXCO Provinsi" ||
          nameExco === "EXCO Kabupaten/Kota" ||
          nameExco === "EXCO KabKot")),
  );

  // doc kantor
  let docKantor = dataDocMap?.filter(
    (item) =>
      item.kategori_dokumen.id === 3 ||
      item.kategori_dokumen.id === 4 ||
      item.kategori_dokumen.id === 5,
  );
  // doc bank
  let docBank = dataDocMap?.filter(
    (item) => item.kategori_dokumen.id === 6 || item.kategori_dokumen.id === 15,
  );

  useEffect(() => {
    dispatch(getExcoDocument(params?.officeId));
    dispatch(getDetailExcoPusat(params?.tingkatExcoId, params?.daerahId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, nameExco]);

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

  //cek hak akses
  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
      return val;
    });
    return has;
  };

  const handleLockUnlock = async () => {
    setIsLockActionLoading(true);
    try {
      // 1. Post request to change lock status
      await dispatch(postLockUnlock({ id_kantor_exco: params?.officeId }));

      // 2. Re-fetch detail data to get the updated 'is_locked' status
      await dispatch(
        getDetailExcoPusat(params?.tingkatExcoId, params?.daerahId),
      );

      // 3. Re-fetch documents if needed (optional but good practice)
      // await dispatch(getExcoDocument(params?.officeId));
    } catch (error) {
      console.error("Error toggling lock:", error);
    } finally {
      setIsLockActionLoading(false);
    }
  };

  // Define Tabs Content
  const baseTabs = [
    {
      id: 0,
      label: "Daftar Kepengurusan",
      content: (
        <Table
          officeId={params.officeId}
          tingkatExcoId={params.tingkatExcoId}
          isLocked={dataDetailExcoPusat?.data?.is_locked}
          nameExco={nameExco}
        />
      ),
    },
    {
      id: 1,
      label: "Dokumen Kepengurusan",
      content: (
        <DokumenKepengurusan
          dataDoc={docPengurusan}
          nameExco={nameExco}
          officeId={params.officeId}
          tingkatExcoId={params.tingkatExcoId}
          daerahId={params.daerahId}
          isLocked={dataDetailExcoPusat?.data?.is_locked}
        />
      ),
    },
    {
      id: 2,
      label: "Dokumen Kantor Tetap",
      content: (
        <Paper elevation={0} style={{ padding: 10 }}>
          <AlamatKantor
            dataDetail={dataDetailExcoPusat?.data}
            nameExco={nameExco}
          />
          <DokumenKantor
            dataDoc={docKantor}
            nameExco={nameExco}
            officeId={params.officeId}
            isLocked={dataDetailExcoPusat?.data?.is_locked}
          />
        </Paper>
      ),
    },
  ];

  // Filter out Kantor Tetap (id 2) if EXCO RT - UPDATED: Allow Kantor Tetap (id 2)
  let tabs = baseTabs;
  if (nameExco?.includes("EXCO RT")) {
    tabs = baseTabs.filter((t) => t.id === 0 || t.id === 1 || t.id === 2);
  }

  // Add Bank Tab only if NOT Kecamatan, NOT Kelurahan, NOT Komisaris Basis, and NOT EXCO RT
  if (
    nameExco !== "EXCO Kelurahan/Desa" &&
    nameExco !== "Komisaris Basis" &&
    nameExco !== "Komisaris RT/RW" &&
    !nameExco?.includes("EXCO RT")
  ) {
    tabs.push({
      id: 3,
      label: "Dokumen Rekening Bank",
      content: (
        <Paper elevation={0} style={{ padding: 10 }}>
          <BankKantor
            dataDetail={dataDetailExcoPusat?.data}
            nameExco={nameExco}
          />
          <DokumenBank
            dataDoc={docBank}
            nameExco={nameExco}
            officeId={params.officeId}
            isLocked={dataDetailExcoPusat?.data?.is_locked}
          />
        </Paper>
      ),
    });
  }

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <Gap height={20} />
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
      <Gap height={20} />
      <div
        style={{
          background: "white",
          paddingLeft: 16,
          paddingRight: 16,
          borderRadius: "20px",
          paddingTop: 8,
          paddingBottom: 20,
        }}
      >
        {nameExco === "EXCO Kelurahan/Desa" ? (
          <div style={{ marginTop: "16px", marginBottom: "16px" }}>
            <div
              style={{ display: "flex", alignItems: "flex-end", gap: "4px" }}
            >
              <div
                onClick={() => setActiveTopTab(0)}
                style={{
                  backgroundColor: activeTopTab === 0 ? "#F06524" : "#FFFFFF",
                  color: activeTopTab === 0 ? "#FFFFFF" : "#757575",
                  padding: "10px 24px",
                  borderRadius: "8px 8px 0 0",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  border:
                    activeTopTab === 0
                      ? "1px solid #F06524"
                      : "1px solid #E0E0E0",
                  borderBottom: "none",
                  boxShadow:
                    activeTopTab !== 0
                      ? "0px -2px 5px rgba(0,0,0,0.02)"
                      : "none",
                }}
              >
                EXCO Kelurahan/Desa:{" "}
                {dataDetailExcoPusat?.data?.alamat?.nama_kel_desa ||
                  dataDetailExcoPusat?.data?.alamat?.nama_kelurahan ||
                  "-"}
              </div>
              <div
                onClick={() => setActiveTopTab(1)}
                style={{
                  backgroundColor: activeTopTab === 1 ? "#F06524" : "#FFFFFF",
                  color: activeTopTab === 1 ? "#FFFFFF" : "#757575",
                  padding: "10px 24px",
                  borderRadius: "8px 8px 0 0",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  border:
                    activeTopTab === 1
                      ? "1px solid #F06524"
                      : "1px solid #E0E0E0",
                  borderBottom: "none",
                  boxShadow:
                    activeTopTab !== 1
                      ? "0px -2px 5px rgba(0,0,0,0.02)"
                      : "none",
                }}
              >
                Komisaris RT/RW
              </div>
            </div>
          </div>
        ) : (
          <p style={{ fontSize: 28, fontWeight: "bold", margin: "8px 0px" }}>
            {nameExco === "EXCO KabKot" ? "EXCO" : nameExco}{" "}
            {dataDetailExcoPusat?.data?.tingkat_exco?.id === 2
              ? dataDetailExcoPusat?.data?.alamat?.nama_provinsi
              : dataDetailExcoPusat?.data?.tingkat_exco?.id === 3
                ? dataDetailExcoPusat?.data?.alamat?.nama_kab_kot
                : dataDetailExcoPusat?.data?.tingkat_exco?.id === 4
                  ? dataDetailExcoPusat?.data?.alamat?.nama_kecamatan
                  : ""}
            {parseInt(dataDetailExcoPusat?.data?.is_locked) === 1 ? (
              <Tooltip title="TERKUNCI, tidak dapat melakukan perubahan data">
                <LockIcon />
              </Tooltip>
            ) : null}
            {/* {state?.nameExco ? state?.nameExco : "EXCO"} */}
          </p>
        )}
        {(nameExco !== "EXCO Kelurahan/Desa" || activeTopTab === 0) && (
          <>
            {checkHakAkses(
              profile?.data?.hak_akses,
              "Document Admin Access",
            ) ? (
              <div
                style={{
                  marginBottom: 24,
                  marginTop: 16,
                  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23BDBDBD' stroke-width='1.5' stroke-dasharray='10%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                {parseInt(dataDetailExcoPusat?.data?.is_locked) === 1 ? (
                  // STATE: LOCKED -> Show "Terkunci" (Red)
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <MyButton
                      startIcon={<LockIcon />}
                      height="38px"
                      color="#D32F2F"
                      colorHover="#D32F2F"
                      fullWidth={true}
                      backgroundColor="#FFEBEE"
                      borderColor="#FFEBEE"
                      backgroundColorHover="#FFCDD2"
                      variant="contained"
                      children={isLockActionLoading ? "Loading..." : "Terkunci"}
                      onClick={isLockActionLoading ? null : handleLockUnlock}
                      style={{
                        borderRadius: "8px",
                        fontWeight: "bold",
                        fontSize: "14px",
                        textTransform: "none",
                        boxShadow: "none",
                      }}
                    />
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#9E9E9E",
                        marginTop: "12px",
                        textAlign: "center",
                        margin: "12px 0 0 0",
                      }}
                    >
                      Tidak dapat melakukan perubahan karna status terkunci.
                      Klik tombol diatas untuk membuka.
                    </p>
                  </div>
                ) : (
                  // STATE: UNLOCKED -> Show "Tidak Terkunci" (Orange Outline)
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <MyButton
                      startIcon={<LockOpenIcon />}
                      height="38px"
                      color="#F06524"
                      colorHover="#F06524"
                      fullWidth={true}
                      backgroundColor="#FFFFFF"
                      borderColor="#F06524"
                      backgroundColorHover="#FFF3E0"
                      variant="outlined"
                      children={
                        isLockActionLoading ? "Loading..." : "Tidak Terkunci"
                      }
                      onClick={isLockActionLoading ? null : handleLockUnlock}
                      style={{
                        borderRadius: "8px",
                        fontWeight: "bold",
                        fontSize: "14px",
                        textTransform: "none",
                        borderWidth: "1.5px",
                      }}
                    />
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#9E9E9E",
                        marginTop: "12px",
                        textAlign: "center",
                        margin: "12px 0 0 0",
                      }}
                    >
                      Anda dapat melakukan perubahan. Klik tombol untuk
                      mengunci.
                    </p>
                  </div>
                )}
              </div>
            ) : null}
            <br />

            {/* Replaced manual content listing with SharedTabPanel */}
            <SharedTabPanel tabs={tabs} transparent={true} />
          </>
        )}

        {/* RT/RW Placeholder */}
        {nameExco === "EXCO Kelurahan/Desa" && activeTopTab === 1 && (
          <ExcoRTRW />
        )}

        <Gap height={10} />

        {/* <div className="footer-content"></div> */}
      </div>
      <Gap height={100} />
    </div>
  );
};

export default DetailExcoPusat;
